import { render, staticRenderFns } from "./AxRoadSideBar.vue?vue&type=template&id=62543724&scoped=true&"
import script from "./AxRoadSideBar.vue?vue&type=script&lang=js&"
export * from "./AxRoadSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AxRoadSideBar.vue?vue&type=style&index=0&id=62543724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62543724",
  null
  
)

/* custom blocks */
import block0 from "./AxRoadSideBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports